import { AwsRegion } from 'src/types/common/api.types';
import { getStage } from 'src/utils/environmentUtils';

export const ASIN_MAPPING_EXCEPTIONS_REPORT_UNIQUE_CODE = 'ASIN_MAPPING_EXCEPTIONS';

export const ASIN_MAPPING_EXCEPTIONS_REPORT_NAME = 'ASIN Mapping Exceptions';

export const ASIN_MAPPING_EXCEPTIONS_REPORT_ROUTE = '/reports/asin-mapping-exceptions';

export const REPORTS_BUCKET_PREFIX = 'verity-reports';

export const ASIN_MAPPING_EXCEPTIONS_S3_PREFIX = 'reports/asin_mapping_exceptions_report';

export const ASIN_MAPPING_EXCEPTIONS_REGION: AwsRegion = 'us-east-1';

export const EXCEPTION_TYPES = ['NO_ASIN', 'NO_FPN', 'NO_RPN', 'NO_STREET_DATE', 'NO_EOL', 'NO_MSRP'] as const;

export const EXCEPTION_TYPE_LABELS: Record<string, string> = {
  NO_ASIN: 'No ASIN',
  NO_FPN: 'No FPN',
  NO_RPN: 'No RPN',
  NO_STREET_DATE: 'No Street Date',
  NO_EOL: 'No EOL',
  NO_MSRP: 'No MSRP',
};

export const ALL_PRODUCTS_VALUE = '__ALL_PRODUCTS__';

/** Selectable program statuses for the Program Status filter (matches getProgramStatusBadge). */
export const PROGRAM_STATUS_VALUES = ['Active', 'EOL', 'Cancelled', 'Topside'] as const;

/**
 * Program statuses selected by default in the Program Status filter — Active only
 * per requirement; users can broaden to EOL/Cancelled/Topside. Empty selection = all.
 */
export const DEFAULT_PROGRAM_STATUS_FILTER: readonly string[] = ['Active'];

export const getReportsBucket = (): string => {
  const stage = getStage();
  if (stage === 'dev') return `${REPORTS_BUCKET_PREFIX}-alpha`;
  return `${REPORTS_BUCKET_PREFIX}-${stage}`;
};

/** Prefix of the Glue job that generates this report (see DasFintechVerityDataServicesCDK glueJobConfig). */
export const ASIN_MAPPING_EXCEPTIONS_GLUE_JOB_PREFIX = 'verity_asin_mapping_exceptions_report';

/**
 * Resolves the stage-suffixed Glue job name for this report. Mirrors
 * getReportsBucket's stage fallback: local dev has no dedicated Glue job, so it
 * targets the shared alpha job. The job always runs in ASIN_MAPPING_EXCEPTIONS_REGION.
 */
export const getAsinMappingExceptionsGlueJobName = (): string => {
  const stage = getStage();
  const jobStage = stage === 'dev' ? 'alpha' : stage;
  return `${ASIN_MAPPING_EXCEPTIONS_GLUE_JOB_PREFIX}-${jobStage}`;
};

export const getExceptionPartitionURI = (gapType: string): string =>
  `s3://${getReportsBucket()}/${ASIN_MAPPING_EXCEPTIONS_S3_PREFIX}/gap_type=${gapType}/data.json`;

export const getExceptionMetadataURI = (): string =>
  `s3://${getReportsBucket()}/${ASIN_MAPPING_EXCEPTIONS_S3_PREFIX}/metadata.json`;
